export const headers = [
  { key: '_id', label: 'Workflow ID' },
  { key: 'name', label: 'Name' },
  { key: 'internalOrExternal', label: 'Internal OR External' },
  { key: 'qualitativeOrQuantitative', label: 'Qualitative OR Quantitative' },
  { key: 'activityId', label: 'Entity Associated' },
  { key: 'viewDetails', label: 'View Details' },
  { key: 'actions', label: 'Actions' }
];
